import PropTypes from 'prop-types'
import React from 'react'

import { withI18n } from '@thebeansgroup/i18n'

import { getBrandFromConsumerGroup } from '@src/authorisation/helpers'

import Layout from '@components/layout'
import SingleSignOn from '@components/sso'
import ThemedButton from '@components/themed_button'

import LogInForm from './children/log_in_form'
import {
  getTitle,
  getDescription,
  getSignUpLabel,
  getTabLabel
} from './helpers'

const LogInScreen = ({
  t,
  token,
  email,
  logInHandler,
  signUpClickHandler,
  requestErrorHandler,
  emailValueChangeHandler,
  resetPasswordClickHandler,
  wrongPasswordHandler,
  ssoNotFoundHandler,
  country,
  consumerGroup,
  medium,
  offer
}) => {
  const brandName = getBrandFromConsumerGroup(consumerGroup)
  const renderLogInForm = () => {
    return (
      <LogInForm
        token={token}
        email={email}
        logInHandler={logInHandler}
        signUpClickHandler={signUpClickHandler}
        requestErrorHandler={requestErrorHandler}
        emailValueChangeHandler={emailValueChangeHandler}
        wrongPasswordHandler={wrongPasswordHandler}
        country={country}
        consumerGroup={consumerGroup}
      />
    )
  }

  const renderResetPasswordButton = () => {
    return (
      <ThemedButton
        type='tertiary'
        onClick={resetPasswordClickHandler}
      >
        {t('a_forgot_password')}
      </ThemedButton>
    )
  }

  const renderLoginSSO = () => {
    return (
      <SingleSignOn
        type='logIn'
        google
        facebook
        apple
        googleLabel={t('a_log_in_google')}
        facebookLabel={t('a_log_in_facebook')}
        appleLabel='Log in with Apple'
        token={token}
        description={t('m_log_in_using')}
        requestSuccessHandler={logInHandler}
        requestErrorHandler={requestErrorHandler}
        ssoNotFoundHandler={ssoNotFoundHandler}
        medium={medium}
      />
    )
  }

  return (
    <Layout
      title={getTitle(t)}
      description={getDescription(t, consumerGroup, brandName)}
      footerLink={{
        text: t('d_dont_have_account'),
        cta: t('a_sign_up_free'),
        onClick: signUpClickHandler
      }}
      showBlueFooter
      tabs
      activeTabPosition='right'
      tabLabel={getTabLabel(t)}
      inactiveTabLabel={getSignUpLabel(t)}
      consumerGroup={consumerGroup}
      offer={offer}
    >
      {renderLogInForm()}
      {renderResetPasswordButton()}
      {renderLoginSSO()}
    </Layout>
  )
}

LogInScreen.propTypes = {
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  logInHandler: PropTypes.func.isRequired,
  signUpClickHandler: PropTypes.func.isRequired,
  requestErrorHandler: PropTypes.func.isRequired,
  emailValueChangeHandler: PropTypes.func.isRequired,
  resetPasswordClickHandler: PropTypes.func.isRequired,
  wrongPasswordHandler: PropTypes.func.isRequired,
  ssoNotFoundHandler: PropTypes.func.isRequired,
  consumerGroup: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  offer: PropTypes.shape({
    title: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired
  }).isRequired
}

export default withI18n(LogInScreen)
